import { render, staticRenderFns } from "./PPublicProjectFooter.vue?vue&type=template&id=b39f1e5c&scoped=true&"
import script from "./PPublicProjectFooter.vue?vue&type=script&lang=ts&"
export * from "./PPublicProjectFooter.vue?vue&type=script&lang=ts&"
import style0 from "./PPublicProjectFooter.vue?vue&type=style&index=0&id=b39f1e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39f1e5c",
  null
  
)

export default component.exports